import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { watchApi } from 'Utils/api';
import {
  fetchWatchBySlugRequest,
  fetchWatchBySlugSuccess,
  fetchWatchBySlugFailure,
} from 'Redux/Slices/WatchSlice';

export const fetchWatchBySlugEpic = (action$: any) =>
  action$.pipe(
    ofType(fetchWatchBySlugRequest.type),
    mergeMap((action: any) =>
      from(watchApi.getWatchBySlug(action.payload)).pipe(
        map((response) => fetchWatchBySlugSuccess(response.data.data)),
        catchError((error) =>
          of(fetchWatchBySlugFailure(error.response?.data?.error || 'Failed to fetch watch'))
        )
      )
    )
  );
